<template>
	<div class="gc-container">
		<GiftCardHeader />

		<div id="gc-check" class="">
			<div class="gc-wrapper">
				<button id="gc-check-expand" @click="toggleCardCheckUI()">
					<span>{{ wpOptions.check_balance_text_link }}</span>
					<ARROWDOWN class="arrow-down" />
				</button>
				<div class="extra">
					<p class="desc-text">{{ wpOptions.check_balance_desc }}</p>
					<br />
					<input
						id="gc-check-input"
						type="text"
						maxlength="20"
						:placeholder="wpOptions.check_balance_input_placeholder"
						v-model="checkCardBalanceID"
					/>
					<button id="gc-check-submit" @click="checkCardBalance()">
						<span>{{ wpOptions.check_balance_button_text }}</span>
						<img id="gc-check-loader" :src="wpData.assets_url + '/svg/loader.svg'" alt="" />
					</button>
					<span id="gc-check-result" v-if="checkCardBalanceAmount !== null"
						>{{ wpOptions.check_balance_amount_text }} <em>{{ checkCardBalanceAmount }}</em
						><i>₪</i></span
					>
					<p id="gc-check-error" v-if="checkCardBalanceError">{{ checkCardBalanceError }}</p>
				</div>
			</div>
		</div>

		<div id="cards">
			<div class="gc-wrapper">
				<div class="gc-flex">
					<h2 class="ff-raanan">{{ wpOptions.cards_title }}</h2>
					<router-link to="/gift-card/companies" class="companies-link"
						>{{ wpOptions.companies_link_text }}
						&nbsp; >
					</router-link>
				</div>
				<ul>
					<li v-for="(card, i) in wpData.globalOptions.gift_cards" :key="card.cash_value">
						<img :src="card.image" :alt="card.title" />
						<p class="card-value">
							<span class="sign">₪</span>
							<span class="num">{{ card.cash_value }}</span>
						</p>
						<div class="controls-container">
							<div class="controls">
								<button @click="minus(i)">-</button>
								<input
									type="number"
									v-model="cards[i].quantity"
									:class="{ grey: cards[i].quantity == 0 }"
								/>
								<button @click="plus(i)">+</button>
							</div>
						</div>
						<p class="desc">{{ card.desc }}</p>
					</li>
				</ul>
			</div>
		</div>

		<GiftCardNav :step="1" :buttonDisabled="!hasCardsSelected" />

		<!-- <button @click="pay()">לתשלום</button> -->
	</div>
</template>

<script>
	import GiftCardHeader from "../../components/GiftCard/GiftCardHeader.vue";
	import GiftCardNav from "../../components/GiftCard/GiftCardNav.vue";
	import ARROWDOWN from "../../assets/img/arrow_down.svg";

	export default {
		name: "Purchase",
		metaInfo: {
			title: wpData.globalOptions.gc_page_purchase.seo_title || "",
			meta: [
				{
					name: "description",
					content: wpData.globalOptions.gc_page_purchase.seo_desc || "",
				},
			],
		},
		data() {
			return {
				wpData: wpData,
				wpOptions: wpData.globalOptions.gc_page_purchase,
				wpNavOptions: wpData.globalOptions.gc_purchase_nav,
				checkCardBalanceID: "",
				checkCardBalanceError: "",
				checkCardBalanceAmount: null,
				cards: this.$store.state.giftCardPurchase,
			};
		},
		methods: {
			toggleCardCheckUI() {
				let isActive = document.querySelector("#gc-check").classList.toggle("active");
				let eventLabel = isActive ? "Show" : "Hide";
				if (typeof ga !== "undefined") {
					ga.getAll()[0].send({
						hitType: "event",
						eventCategory: "Gift cards",
						eventAction: "Purchase page - " + eventLabel + " balance check UI",
						eventLabel: "",
						eventValue: 0,
						nonInteraction: false,
					});
				}
			},

			checkCardBalance() {
				this.checkCardBalanceError = null;
				this.checkCardBalanceAmount = null;

				const cardID = parseInt(this.checkCardBalanceID);
				if (!cardID || cardID < 100000) {
					this.checkCardBalanceError = this.wpOptions.check_balance_errors_invalid;
					return false;
				}

				const button = document.querySelector("#gc-check-submit");
				if (button.classList.contains("loading")) {
					return false;
				}

				button.classList.add("loading");

				if (typeof ga !== "undefined") {
					ga.getAll()[0].send({
						hitType: "event",
						eventCategory: "Gift cards",
						eventAction: "Check card balance",
						eventLabel: "Card code: " + cardID,
						eventValue: 0,
						nonInteraction: false,
					});
				}

				fetch(wpData.ajax_url + "?action=cgc_checkGiftCard&cardID=" + cardID)
					.then((r) => {
						button.classList.remove("loading");
						return r.json();
					})
					.then((r) => {
						if (!r.success) {
							this.checkCardBalanceError = r.data;
							// switch ( r.error_num ) {
							// 	case 100:
							// 		this.checkCardBalanceError = this.wpOptions.check_balance_errors_invalid;
							// 		break;
							// 	case 101:
							// 		this.checkCardBalanceError = this.wpOptions.check_balance_errors_api;
							// 		break;
							// 	case 102:
							// 		this.checkCardBalanceError = this.wpOptions.check_balance_errors_not_found;
							// 		break;
							// }
						} else {
							this.checkCardBalanceAmount = r.data.balance;
						}
					});
			},

			// OLD STARTS HERE

			plus(i) {
				this.cards[i].quantity++;
				this.$store.commit("setGiftCardPurchaseSelectedCards", this.cards);

				// Google analytics tag
				if (typeof ga !== "undefined") {
					ga.getAll()[0].send({
						hitType: "event",
						eventCategory: "Gift cards",
						eventAction: "Purchase page - Set card quantity",
						eventLabel: "Card value:" + this.cards[i].cash_value + ", Quantity:" + this.cards[i].quantity,
						eventValue: 0,
						nonInteraction: false,
					});
				}
			},
			minus(i) {
				this.cards[i].quantity > 0 && this.cards[i].quantity--;
				this.$store.commit("setGiftCardPurchaseSelectedCards", this.cards);

				// Google analytics tag
				if (typeof ga !== "undefined") {
					ga.getAll()[0].send({
						hitType: "event",
						eventCategory: "Gift cards",
						eventAction: "Purchase page - Set card quantity",
						eventLabel: "Card value:" + this.cards[i].cash_value + ", Quantity:" + this.cards[i].quantity,
						eventValue: 0,
						nonInteraction: false,
					});
				}
			},
			pay() {
				let values = [];
				this.cards.forEach((card) => {
					for (var i = 0; i < card.quantity; i++) {
						values.push(card.value);
					}
				});
				const wp_user_id = window.user.id;
				this.$ajax
					.get(
						this.$wpData.ajax_url +
							"?action=cgc_createOrder&wordpress_user_id=" +
							wp_user_id +
							"&values=" +
							values
					)
					.then((response) => {
						if (!response.data.success) {
							// Handle errors
						} else {
							localStorage.setItem("carmella-payform", response.data.payment_iframe_url);
							window.location = response.data.payment_url;
						}
					});
			},
		},
		computed: {
			hasCardsSelected() {
				return this.cards.reduce((a, i) => parseInt(a) + parseInt(i.quantity), 0) > 0;
			},
		},
		created() {
			let cards = [];
			this.cards.forEach((card, i) => {
				if (!this.cards[i].hasOwnProperty("quantity")) {
					this.$set(this.cards[i], "quantity", 0);
				}
			});
		},
		components: {
			ARROWDOWN,
			GiftCardHeader,
			GiftCardNav,
		},
	};
</script>

<style lang="sass" scoped>

	@import '../../assets/sass/gift-card-abstracts.sass'

	#gc-check
		#gc-check-expand
			text-decoration: underline
			color: $main
			background-color: transparent
			outline: none
			border: none
			font-weight: bold
			padding-bottom: 1rem

			.arrow-down
				width: 0.85rem
				transform: translate(-7px, 7px)
				transition: transform 250ms ease-out

		&.active
			#gc-check-expand .arrow-down
				transform: translate(-7px, 7px) rotate(180deg)

			.extra
				max-height: 200px

		.extra
			// padding: 1rem 0
			max-height: 0
			transition: max-height 300ms ease-out
			overflow: hidden

		.desc-text
			white-space: pre-line

		#gc-check-input
			border: none
			border-radius: 0px
			font-size: 1rem
			width: 11.5rem

		#gc-check-submit
			background: $main
			color: $white
			border: none
			outline: none
			padding: 0.5rem 2rem
			border-radius: 5rem
			margin-right: 1rem
			position: relative

			&:hover, &:focus
				background-color: lighten($main, 4%)

			&:active
				background-color: lighten($main, 7%)

			#gc-check-loader
				position: absolute
				top: 50%
				left: 50%
				transform: translate(-50%, -50%)
				display: none

			&.loading
				#gc-check-loader
					display: block

				span
					opacity: 0

		#gc-check-result
			margin-right: 1rem
			font-size: 1.5rem
			+mobile
				display: block
				margin-right: 0
				margin-top: 0.5rem

			em, i
				font-style: normal

			i
				font-size: 1rem
				display: inline-block
				margin-right: 2px

		#gc-check-error
			margin: 0.5rem 0
			color: $error

	#cards

		margin-top: 3rem

		.gc-flex
			display: flex
			+mobile
				flex-wrap: wrap
				justify-content: flex-start

		h2
			font-size: 3rem
			font-weight: 300
			+mobile
				width: 100%

		.companies-link
			background-color: $companies_link_bg
			color: $white
			font-weight: bold
			padding-right: 0.25rem
			display: block
			border-radius: 5rem
			padding: 0.75rem 1.25rem
			height: 2.5rem
			line-height: 1
			transform: translate(-1.5rem, 3px)

			&:hover, &:focus
				background-color: lighten($companies_link_bg, 5%)

			&:active
				background-color: lighten($companies_link_bg, 8%)

			+mobile
				font-size: 0.85rem
				height: 2rem
				padding: 0.5rem 1rem
				line-height: 1.25
				transform: translate(0, 0)
				margin-bottom: 1.5rem

		ul
			margin: 1rem 0 0 0
			display: flex
			justify-content: space-between
			flex-wrap: wrap
			width: 42vw
			+tablet
				width: 100%

			li
				list-style-type: none
				position: relative
				width: calc(21vw - 1rem)
				text-align: center
				padding-right: 0
				margin-bottom: 1.25rem
				+tablet
					width: calc(50% - 1rem)
				+mobile
					width: 100%

				&:before
					display: none

				img
					width: 100%
					margin: 0 auto 1rem auto
					border-radius: 1rem
					box-shadow: 0 0.5rem 1rem 0 rgba(darken($bg, 50%), 0.3)
					+tablet
				// transform: translateX(4.5%)
				.card-value
					color: $dark
					position: absolute
					top: 2vw
					transform: translateY(-20%)
					left: 3vw

					.num
						font-size: 3rem

					.sign
						font-size: 1rem

					+tablet
						top: 5vw
						left: 7vw
						.num
							font-size: 2.5rem
						.sign
							font-size: 1rem
					+mobile
						top: 9vw
						left: 13vw
						.num
							font-size: 2.5rem
						.sign
							font-size: 1rem


				.controls
					display: flex
					justify-content: center
					width: 10rem
					margin: 0 auto
					background-color: $white
					border-radius: 0.5rem
					border: 1px solid darken($white, 20%)
					overflow: hidden

					input
						width: 4rem
						border: none
						outline: none
						text-align: center
						font-size: 1.25rem

						&.grey
							color: darken($white, 40%)

					button
						width: 3rem
						height: 3rem
						font-size: 1.25rem
						text-align: center
						font-weight: bold
						color: $main
						background: transparent
						border: none
						outline: none

						&:hover
							background-color: $main
							color: $white

						&:active
							background-color: lighten($main, 4%)

				.desc
					text-align: center
					font-weight: normal
					margin: 1rem auto 1.5rem auto
					font-size: 1.15rem
					+tablet
						margin: 0.75rem auto 1rem auto
</style>
